import styled from '@emotion/styled'
import { fhirclient } from 'fhirclient/lib/types';
import React from 'react';

export type PatientBannerProps = {
  patient: fhirclient.FHIR.Patient;
}

function Name({ name = Array<any>()}) {
  let entry = name.find(nameRecord => nameRecord.use === "official") || name[0];

  const Content = styled.div`
    padding-left: 0.5rem;
  `

  if (!entry) {
      return <div>No Name</div>;
  }
  return <Content>{entry.given.join(" ") + " " + entry.family}</Content>;
}

export function PatientBanner({ patient }: PatientBannerProps){

  const Content = styled.div`
    display: grid;
    grid-template-columns: fit-content(500px) fit-content(500px) fit-content(500px);
    justify-items: left;
    align-items: center;
    grid-gap: 0px;
    padding: 0px;
  `

  const PatientName = styled.div`
    display: flex;
    grid-column: 1 / 2;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  `
  
  return (
        <Content>
            <PatientName>
              <b>Patient:</b> <Name name={patient.name}></Name>
            </PatientName>
        </Content>
  );
}
